if ( isInvestorsPage ) {

	const url = 'https://sec.report/CIK/0001679817.rss';
	const rssUrl = `/app/themes/Volum8WP/assets/functions/inc/CORS_Proxy.php?url=${url}`;
	const rssFilings = document.querySelector( '[data-rss-filings]' );

	fetch( rssUrl )
		.then( response => response.json() )
		.then( data => {

			const xmlData = data.contents.substring( data.contents.indexOf( '<?xml version' ) );
			const contents = new window.DOMParser().parseFromString( xmlData, 'text/xml' );
			const downloadIcon = '<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 19.982"><path d="M2,7.982v10H16v-10H12v-2h6v14H0v-14H6v2Z" /><path d="M10,0H8V12.053L5.465,9.517,4.05,10.932,9,15.882l4.95-4.95L12.536,9.518,10,12.053Z" /></svg>';

			const items = contents.querySelectorAll( 'item' );

			console.log( items );
			const filings = [];

			items.forEach( item => {
				const filing = {};
				filing.startDate = item.querySelector( 'pubDate' ).textContent;
				filing.description = item.querySelector( 'description' ).textContent;
				filing.form = item.querySelector( 'title' ).textContent;
				filing.link = item.querySelector( 'link' ).textContent;

				const filingRow = document.createElement( 'tr' );

				const filingDate = document.createElement( 'td' );
				filingDate.classList.add( 'date' );
				const articleDateObject = new Date( filing.startDate );
				const month = articleDateObject.toLocaleString( 'default', { month: 'long' } );
				const formatDate = `${month} ${articleDateObject.getDate()}, ${articleDateObject.getFullYear()}`;
				filingDate.textContent = formatDate;

				const filingForm = document.createElement( 'td' );
				filingForm.classList.add( 'form' );
				filingForm.textContent = filing.form;

				const filingDescription = document.createElement( 'td' );
				filingDescription.classList.add( 'description' );
				filingDescription.textContent = filing.description;

				const filingDownload = document.createElement( 'td' );
				filingDownload.classList.add( 'download' );

				const filingLink = document.createElement( 'a' );
				filingLink.target = '_blank';
				filingLink.setAttribute( 'aria-label', 'Download filing' );
				filingLink.classList.add( 'flex', 'items-center', 'justify-center', 'w1', 'h-1', 'blue', 'hover-black' );
				filingLink.innerHTML = downloadIcon;
				filingLink.href = filing.link;

				filingRow.appendChild( filingDate );
				filingRow.appendChild( filingForm );
				filingRow.appendChild( filingDescription );
				filingRow.appendChild( filingDownload );
				filingDownload.appendChild( filingLink );

				filings.push( filingRow );
				rssFilings.appendChild( filingRow );
			});

			console.log( filings );

		})
		.then( () => {
			const filingsTable = new simpleDatatables.DataTable( '[data-filings-table]', {
				searchable: true,
				fixedHeight: false,
			});

			const dropdown = document.querySelector( '.dataTable-dropdown' );
			const perPage = document.querySelector( '.dataTable-dropdown label' );
			const entriesText = perPage.childNodes[1].textContent;
			perPage.childNodes[1].textContent = '';
			const entriesPerPage = document.createElement( 'span' );
			entriesPerPage.classList.add( 'db', 'pl2' );
			entriesPerPage.textContent = entriesText;
			dropdown.appendChild( entriesPerPage );
		});

}
